export const GTV_LIFETIME_SKU = 'cju-ls';
